/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLinks } from '../fn/root/get-links';
import { GetLinks$Params } from '../fn/root/get-links';
import { RepresentationModelObject } from '../models/representation-model-object';


/**
 * API entry point. Returns HATEOAS links to all top-level resources.
 */
@Injectable({ providedIn: 'root' })
export class RootService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLinks()` */
  static readonly GetLinksPath = '/';

  /**
   * Get API root links.
   *
   * Returns a HAL response containing links to all top-level API resources. 
   * Use this as the starting point for API navigation.
   *
   * **Required role (one of):** `EASYLOT_ADMIN` or `PRICE_SYNC_ADMIN`
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks$Response(params?: GetLinks$Params, context?: HttpContext): Observable<StrictHttpResponse<RepresentationModelObject>> {
    const obs = getLinks(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get API root links.
   *
   * Returns a HAL response containing links to all top-level API resources. 
   * Use this as the starting point for API navigation.
   *
   * **Required role (one of):** `EASYLOT_ADMIN` or `PRICE_SYNC_ADMIN`
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks(params?: GetLinks$Params, context?: HttpContext): Observable<RepresentationModelObject> {
    const resp = this.getLinks$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RepresentationModelObject>): RepresentationModelObject => r.body)
    );
  }

}
